import React from 'react';
import { useNavigate } from 'react-router-dom';

export function LogoutButton() {
  const navigate = useNavigate();

  const handleLogout = () => {
    localStorage.removeItem('adminToken');
    navigate('/admin/login');
  };

  return (
    <button
      onClick={handleLogout}
      className="text-gray-400 hover:text-white transition-colors"
    >
      Log out
    </button>
  );
} 